<template>
  <div class="minha-conta" :class="{ 'full-height': registros.length == 0 && !loading }">
    <header class="bg-dark py-2">
      <div class="container">
        <div class="row">
          <div class="col">
            <router-link to="/">
              <img src="/img/logo.svg" width="150" height="34" />
            </router-link>
            <span class="badge badge-success ml-2">admin</span>
          </div>
          <div class="col text-right">
            <SideNav />
          </div>
        </div>
      </div>
    </header>
    <div class="bg-gradient">
      <div class="container text-center pt-3">
        <h3>Registros</h3>
        <div class="h-line titulo-linha"></div>
      </div>
    </div>

    <div class="container mt-5 pb-5">
      <b-card class="mb-5 my-card">
        <div class="row my-3 mx-1 justify-content-center">
          <div class="col-md-6 mb-2">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">Nº de Série</span>
              </div>
              <input
                type="text"
                class="form-control"
                v-model="numeroSerie"
                placeholder="Ex: UV16;H526141"
              />
            </div>
            <small class="form-text text-muted">Separe múltiplos blocos com ponto e vírgula (;)</small>
          </div>
          <div class="col-md-3 mb-2">
            <button
              type="submit"
              class="btn btn-success btn-block"
              @click.prevent="buscar()"
              :disabled="loading"
            >
              <span v-if="!loading">Buscar</span>
              <span v-if="loading">Aguarde...</span>
            </button>
          </div>
        </div>
      </b-card>

      <div class="row">
        <div class="col-lg-12">
          <div class="text-center" v-if="registros.length == 0 && !loading && buscaRealizada">
            <p>Nenhum registro encontrado para o número de série informado.</p>
          </div>
          <div v-if="!loading">
            <b-card
              no-body
              class="mb-4 my-card"
              v-for="(registro, index) in registros"
              :key="'registro' + index"
            >
              <div class="row p-3 align-items-center">
                <!-- Foto + nome do cliente -->
                <div class="col-md-2 text-center">
                  <img
                    v-if="registro.foto"
                    :src="registro.foto"
                    class="rounded-circle foto-cliente"
                    width="70"
                    height="70"
                    @error="registro.foto = null"
                  />
                  <div
                    v-else
                    class="rounded-circle d-inline-flex align-items-center justify-content-center font-weight-bold text-white avatar-inicial"
                  >
                    {{ registro.cliente ? registro.cliente.charAt(0).toUpperCase() : '?' }}
                  </div>
                  <p class="mt-2 mb-0 font-weight-bold nome-cliente">{{ registro.cliente }}</p>
                  <small class="text-muted email-cliente">{{ registro.emailCliente }}</small>
                </div>

                <!-- Dados resumidos em colunas -->
                <div class="col-md-3">
                  <p class="mb-1 break-all"><b>Registro #:</b> {{ registro.numeroRegistro }}</p>
                  <p class="mb-1"><b>Marca:</b> {{ registro.marca }}</p>
                  <p class="mb-1"><b>Modelo:</b> {{ registro.modelo }}</p>
                </div>
                <div class="col-md-3">
                  <p class="mb-1"><b>CPF:</b> {{ registro.cpf }}</p>
                  <p class="mb-1">
                    <b>Status:</b>
                    <span :class="registro.status === 'Registrada' ? 'badge badge-success ml-1' : 'badge badge-secondary ml-1'">
                      {{ registro.status }}
                    </span>
                  </p>
                  <p class="mb-1"><b>Data Registro:</b> {{ formatarData(registro.dataRegistro) }}</p>
                </div>

                <!-- Ações -->
                <div class="col-md-4 d-flex flex-column justify-content-center align-items-center">
                  <button
                    class="btn btn-outline-secondary btn-block mb-2"
                    @click.prevent="verDetalhes(registro)"
                  >
                    Ver Detalhes
                  </button>
                  <button
                    class="btn btn-success btn-block"
                    @click.prevent="abrirTransferencia(registro)"
                  >
                    Transferir Bike
                  </button>
                </div>
              </div>

            </b-card>
          </div>
        </div>
      </div>
    </div>

    <Loading :criandoSeguro="true" v-if="loading" />

    <!-- Modal Detalhes -->
    <b-modal
      v-if="registroSelecionado"
      v-model="showModalDetalhes"
      title="Detalhes do Registro"
      size="lg"
      hide-footer
    >
      <div class="row">
        <div class="col-md-6">
          <p><b>ID:</b> {{ registroSelecionado.id }}</p>
          <p class="break-all"><b>Registro #:</b> {{ registroSelecionado.numeroRegistro }}</p>
          <p><b>Status:</b> {{ registroSelecionado.status }}</p>
          <p><b>Tag:</b> {{ registroSelecionado.tag }}</p>
          <p><b>Marca:</b> {{ registroSelecionado.marca }}</p>
          <p><b>Modelo:</b> {{ registroSelecionado.modelo }}</p>
          <p><b>Tipo:</b> {{ registroSelecionado.tipo }}</p>
          <p><b>Cor:</b> {{ registroSelecionado.corBike }}</p>
          <p><b>Data Registro:</b> {{ formatarData(registroSelecionado.dataRegistro) }}</p>
        </div>
        <div class="col-md-6">
          <p><b>Cliente:</b> {{ registroSelecionado.cliente }}</p>
          <p><b>E-mail:</b> {{ registroSelecionado.emailCliente }}</p>
          <p><b>CPF:</b> {{ registroSelecionado.cpf }}</p>
          <p><b>Celular:</b> {{ registroSelecionado.celular }}</p>
          <p><b>Sexo:</b> {{ registroSelecionado.sexo }}</p>
          <p><b>Nascimento:</b> {{ formatarData(registroSelecionado.dataNascimento) }}</p>
          <p><b>Cidade:</b> {{ registroSelecionado.cidade }} / {{ registroSelecionado.uf }}</p>
        </div>
      </div>
      <div class="row mt-2" v-if="registroSelecionado.fotosRegistro && registroSelecionado.fotosRegistro.length > 0">
        <div class="col-12 mb-2"><b>Fotos:</b></div>
        <div class="col-auto" v-for="(foto, fi) in registroSelecionado.fotosRegistro" :key="'mfoto' + fi">
          <a :href="foto.urlImage" target="_blank">
            <img :src="foto.urlThumbnail" width="100" height="100" class="rounded mr-2 foto-thumb" />
          </a>
        </div>
      </div>
    </b-modal>

    <!-- Modal Transferência -->
    <b-modal
      v-if="registroSelecionado"
      v-model="showModalTransferencia"
      title="Transferir Bike para Novo Dono"
      hide-footer
    >
      <div class="mb-3">
        <p class="break-all">
          Transferindo registro <b>#{{ registroSelecionado.numeroRegistro }}</b> —
          {{ registroSelecionado.marca }} {{ registroSelecionado.modelo }}
        </p>
        <p class="break-all">Dono atual: <b>{{ registroSelecionado.cliente }}</b> ({{ registroSelecionado.emailCliente }})</p>
      </div>
      <div class="form-group">
        <label><b>E-mail do novo dono:</b></label>
        <input
          type="email"
          class="form-control"
          v-model="emailNovoProprietario"
          placeholder="novo@email.com"
        />
      </div>
      <div class="text-right mt-3">
        <button class="btn btn-secondary mr-2" @click="showModalTransferencia = false">Cancelar</button>
        <button
          class="btn btn-success"
          @click.prevent="confirmarTransferencia()"
          :disabled="loadingTransferencia || !emailNovoProprietario"
        >
          <span v-if="!loadingTransferencia">Confirmar Transferência</span>
          <span v-if="loadingTransferencia">Aguarde...</span>
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import SideNav from "../../components/Admin/SideNav";
import config from "../../config";
import auth from "../../auth";
import Swal from "sweetalert2";
import axios from "axios";
import captureError from "../../helpers/captureError";
import Loading from "../../components/Usuario/Loading.vue";

export default {
  components: {
    SideNav,
    Loading,
  },
  data() {
    return {
      config,
      loading: false,
      loadingTransferencia: false,
      numeroSerie: "",
      registros: [],
      buscaRealizada: false,
      registroSelecionado: null,
      showModalDetalhes: false,
      showModalTransferencia: false,
      emailNovoProprietario: "",
    };
  },
  created() {
    var userInfo = auth.getUserInfo();
    if (userInfo && userInfo.cargo) {
      // authorized
    } else {
      this.$router.replace("/login");
    }
  },
  methods: {
    formatarData(data) {
      if (!data) return "—";
      try {
        return new Date(data).toLocaleDateString("pt-BR");
      } catch {
        return data;
      }
    },

    async buscar() {
      if (!this.numeroSerie || !this.numeroSerie.trim()) {
        Swal.fire({ icon: "warning", text: "Informe o número de série." });
        return;
      }

      const blocos = this.numeroSerie
        .split(";")
        .map((b) => b.trim())
        .filter((b) => b.length > 0);

      if (blocos.length === 0) {
        Swal.fire({ icon: "warning", text: "Número de série inválido." });
        return;
      }

      this.loading = true;
      this.registros = [];
      this.buscaRealizada = false;

      try {
        var response = await axios.post(
          `${config.API_URLV2}/registro/buscarNumeroRegistroPorTag`,
          { listaRegistros: blocos }
        );

        this.registros = Array.isArray(response.data)
          ? response.data
          : response.data
          ? [response.data]
          : [];
        this.buscaRealizada = true;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.buscaRealizada = true;
        captureError(error);
        Swal.fire({
          icon: "error",
          text: "Não foi possível realizar a busca. Tente novamente ou contate o suporte.",
        });
      }
    },

    verDetalhes(registro) {
      this.registroSelecionado = registro;
      this.showModalDetalhes = true;
    },

    abrirTransferencia(registro) {
      this.registroSelecionado = registro;
      this.emailNovoProprietario = "";
      this.showModalTransferencia = true;
    },

    async confirmarTransferencia() {
      if (!this.emailNovoProprietario || !this.emailNovoProprietario.trim()) {
        Swal.fire({ icon: "warning", text: "Informe o e-mail do novo proprietário." });
        return;
      }

      if (this.emailNovoProprietario.trim().toLowerCase() === this.registroSelecionado.emailCliente.trim().toLowerCase()) {
        Swal.fire({ icon: "warning", text: "O e-mail do novo dono não pode ser o mesmo do dono atual." });
        return;
      }

      const confirm = await Swal.fire({
        icon: "question",
        title: "Confirmar transferência?",
        html: `A bike será transferida para <b>${this.emailNovoProprietario}</b>. Esta ação não pode ser desfeita.`,
        showCancelButton: true,
        confirmButtonText: "Sim, transferir",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#28a745",
      });

      if (!confirm.isConfirmed) return;

      this.loadingTransferencia = true;

      try {
        await axios.post(
          `${config.API_URLV2}/TransferenciaBike/ConfirmarTransferenciaAdmin`,
          {
            idRegistro: this.registroSelecionado.id,
            email: this.emailNovoProprietario.trim(),
          }
        );

        this.loadingTransferencia = false;
        this.showModalTransferencia = false;

        await this.$nextTick();

        Swal.fire({
          icon: "success",
          title: "Transferência realizada!",
          text: `A bike foi transferida para ${this.emailNovoProprietario}.`,
        });

        await this.buscar();
      } catch (error) {
        this.loadingTransferencia = false;
        captureError(error);
        Swal.fire({
          icon: "error",
          text: "Não foi possível realizar a transferência. Tente novamente ou contate o suporte.",
        });
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&display=swap");

.full-height {
  height: 100vh;
}

.titulo-linha {
  width: 140px;
}

.my-card {
  border-radius: 15px !important;
  border: none !important;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
}

.foto-cliente {
  object-fit: cover;
}

.foto-thumb {
  object-fit: cover;
}

.nome-cliente {
  font-size: 0.85rem;
}

.email-cliente {
  font-size: 0.75rem;
}

.break-all {
  word-break: break-all;
}

.avatar-inicial {
  width: 70px;
  height: 70px;
  font-size: 1.8rem;
  background-color: #23ad21;
}

.bg-gradient {
  color: black;
  padding: 20px 0;
}
</style>
